/* eslint-disable no-return-assign, react/jsx-no-bind */
import React from 'react';
import Localization from 'es6/services/localization';
import FitText from 'es6/components/common/fit-text';
import { Navigation, NavButton } from 'es6/components/apps/navigation';
import SoundManager from 'es6/services/sound-manager';

/**
 * @this SelfAssessment
 * @returns {String}
 */
function getPrompt() {
  const { isNew, isRepeat } = this.props;

  if (isRepeat) {
    return Localization.t('prompt-repeat');
  } else if (isNew) {
    return Localization.t('prompt-new');
  } else {
    return Localization.t('prompt-review');
  }
}

/**
 * @this SelfAssessment
 * @returns {ReactElement}
 */
function renderBadge() {
  const className = 'screen-badge screen-badge-repeat-item';
  const { isNew, isRepeat } = this.props;

  if (isRepeat) {
    return (<span className={className}>{Localization.t('badge-repeat')}</span>);
  } else if (isNew) {
    return (<span className={className}>{Localization.t('js_iknow.new item')}</span>);
  }

  return null;
}

class SelfAssessment extends React.Component {
  constructor(...args) {
    super(...args);

    this.state = {
      handleClick: this.props.onReveal.bind(this),
    };

    this.saveNavigationRef = ref => this.navigationRef = ref;
  }

  componentDidMount() {
    const { cueSound } = this.props;

    if (cueSound) {
      SoundManager.play(cueSound);
    }

    this.refs.screen.addEventListener('click', this.state.handleClick);
  }

  componentWillUpdate() {
    this.componentWillUnmount();
  }

  componentDidUpdate(prevProps, prevState) {
    this.componentDidMount();

    // Refocus the Next button when a new cue is shown.
    if (this.props.cue !== prevProps.cue) {
      this.navigationRef && this.navigationRef.focusDefaultButton(true);
    }
  }

  componentWillUnmount() {
    this.refs.screen.removeEventListener('click', this.state.handleClick);
  }

  render() {
    const { cue, onReveal, onSkip, response } = this.props;
    const removeTooltip = Localization.t('js_iknow.remove');

    return (
      <div className="screen screen-self-assessment">
        <div ref="screen" className="screen-content">
          {renderBadge.call(this)}

          <div className="message">
            <p className="know">{getPrompt.call(this)}</p>
          </div>

          <div className="cue-response">
            <div className="cue">
              <div className="content">
                <div className="bottom">
                  <FitText minFontSize={20}>{cue || '?'}</FitText>
                </div>
              </div>
            </div>

            <div className="cue-response-separator" />

            <div className="response">
              <FitText minFontSize={20}>{response || '?'}</FitText>
            </div>
          </div>
        </div>

        <Navigation ref={this.saveNavigationRef}>
          <NavButton align="left" className="btn-nav-icon btn-danger" focusable onClick={onSkip.bind(this)} title={removeTooltip}>
            <span className="glyph glyph-remove" />
          </NavButton>

          <NavButton align="right" focused focusable onClick={onReveal.bind(this)}>
            {Localization.t('self-assessment.check')}
          </NavButton>
        </Navigation>
      </div>
    );
  }
}

SelfAssessment.propTypes = {
  cue: React.PropTypes.string,
  cueSound: React.PropTypes.string,
  isNew: React.PropTypes.bool.isRequired,
  isRepeat: React.PropTypes.bool.isRequired,
  onReveal: React.PropTypes.func.isRequired,
  onSkip: React.PropTypes.func.isRequired,
  response: React.PropTypes.string,
};

export default SelfAssessment;
